export enum ComponentState {
  NONE,
  LOADING,
  DATA,
  ERROR
}
